// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__15HmB","file":"styles_file__2LDvA"};